export default __webpack_public_path__ + "static/media/gmo.70a67bba.svg";